import type { DraftCollaborator } from '@/drafting/hooks/useDraftCollaboration';

export const draftCollaboratorIdentityKey = (collaborator: DraftCollaborator) => {
  const email = collaborator.email?.trim().toLowerCase();
  if (email) return `email:${email}`;

  const name = collaborator.name.trim().toLowerCase();
  if (name) return `name:${name}`;

  return `client:${collaborator.clientId}`;
};

export const uniqueDraftCollaborators = (collaborators: DraftCollaborator[]) => {
  const seen = new Set<string>();
  return collaborators.filter((collaborator) => {
    const key = draftCollaboratorIdentityKey(collaborator);
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
};

export const draftCollaboratorLabel = (collaborator: DraftCollaborator) => {
  const name = collaborator.name.trim() || collaborator.email?.trim() || 'Unknown user';
  return collaborator.isLocal ? `${name} (you)` : name;
};

export const draftCollaboratorTitle = (collaborator: DraftCollaborator) => {
  const label = draftCollaboratorLabel(collaborator);
  const email = collaborator.email?.trim();
  return email && email !== collaborator.name.trim() ? `${label} - ${email}` : label;
};

export const draftCollaboratorInitials = (collaborator: DraftCollaborator) => {
  const source = collaborator.name.trim() || collaborator.email?.trim().replace(/@.*/, '') || '';
  const words = source
    .replace(/[._-]+/g, ' ')
    .split(/\s+/)
    .filter(Boolean);

  if (words.length >= 2) return `${words[0][0]}${words[1][0]}`.toUpperCase();
  return (words[0]?.slice(0, 2) || '?').toUpperCase();
};
